/*
 * @Author: your name
 * @Date: 2021-06-03 10:39:51
 * @LastEditTime: 2021-06-24 10:25:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fm-client\src\components\index.js
 */
import HEAD from '@/components/Head.vue'
import FOOTER from '@/components/Footer.vue'
export default {
    install: function (Vue) {
        Vue.component('public-head', HEAD)
        Vue.component('public-footer', FOOTER)
    }
}


// WEBPACK FOOTER //
// ./src/components/index.js